import { CollectionOpts, Resource, ResourceType, isLoadingStatus, useCollection, useResource } from 'json-api-hooks';
import { useMemo } from 'react';
import { useWatch } from 'react-hook-form';

import toString from '../../../lib/toString';
import { FormFieldAttribute, FormFieldOption, ResourceFieldAttributes } from '../ResourceForm';

export interface FieldOptions {
  loading: boolean;
  options: FormFieldOption[];
}

const useFieldOptions = (
  staticOptions: FormFieldOption[] | undefined,
  resource: Resource | undefined,
  resourceType?: ResourceType,
  resourceOpts?: CollectionOpts | ((props: ResourceFieldAttributes<void>) => CollectionOpts),
): FieldOptions => {
  const formValues = useWatch() as Record<FormFieldAttribute<ResourceType>, string>;
  const [session] = useResource({ id: '', type: 'sessions' });
  const resolvedResourceOpts = useMemo(() => {
    if (typeof resourceOpts === 'function' && session) {
      return resourceOpts({ session, formValues, resource });
    }

    return resourceOpts as CollectionOpts;
  }, [resourceOpts, session, formValues]);
  const [collectionItems, { status }] = useCollection(resourceType, resolvedResourceOpts);
  const options = useMemo(() => {
    if (staticOptions?.length) {
      return staticOptions;
    }

    return (
      collectionItems?.map((item) => ({
        key: item.id,
        label: toString(item),
      })) ?? []
    );
  }, [collectionItems, staticOptions]);

  return {
    loading: !staticOptions?.length && isLoadingStatus(status),
    options,
  };
};

export default useFieldOptions;
